import { apiClient } from '@store/index';
import { axiosErrorMiddleware } from './common';
import { GlobalVariable, GlobalVariableBaseValues } from '@components/Workspace/routes/GlobalVariables/types';
import { QueryFunctionContext } from '@tanstack/react-query';

type GlobalVariableArgs = {
  serviceId?: string;
};

interface GlobalVariableCreateArgs extends GlobalVariableArgs {
  globalVariable: GlobalVariableBaseValues;
}

interface GlobalVariableUpdateArgs extends GlobalVariableArgs {
  id: string;
  globalVariable: GlobalVariableBaseValues;
}

interface GlobalVariableDeleteArgs extends GlobalVariableArgs {
  id: string;
}

const listVariables = async ({
  queryKey,
}: QueryFunctionContext<[string, string | undefined]>): Promise<GlobalVariable[]> => {
  const [, serviceId] = queryKey;
  const response = await apiClient.get<GlobalVariable[]>(`/${serviceId}/global_variables`);
  return response.data;
};

const createVariable = async ({ serviceId, globalVariable }: GlobalVariableCreateArgs): Promise<GlobalVariable> => {
  try {
    const response = await apiClient.post<GlobalVariable>(`/${serviceId}/global_variables`, globalVariable);
    return response.data;
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

const updateVariable = async ({ serviceId, id, globalVariable }: GlobalVariableUpdateArgs): Promise<GlobalVariable> => {
  try {
    const response = await apiClient.put<GlobalVariable>(`/${serviceId}/global_variables/${id}`, globalVariable);
    return response.data;
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

const deleteVariable = async ({ serviceId, id }: GlobalVariableDeleteArgs): Promise<{ message: string }> => {
  try {
    const response = await apiClient.delete(`/${serviceId}/global_variables/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

export default { listVariables, createVariable, updateVariable, deleteVariable };
